import { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';
import { Toaster } from 'sonner';

import Navigation from './components/Navigation';
import Hero from './components/Hero';
import MarqueeRibbon from './components/MarqueeRibbon';
import About from './components/About';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

import './App.css';

function App() {
  // Initialize Lenis smooth scrolling
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-cream min-h-screen">
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#2E2B28',
            color: '#F5F0EB',
            border: '1px solid #D9CEBF',
          },
        }}
      />
      <Navigation />
      <main>
        <Hero />
        <MarqueeRibbon />
        <Services />
        <Portfolio />
        <About />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
